import Card from '../atoms/card';
import SVGIcon from '../atoms/icons';
import Title from '../atoms/title';
import LanguageSelect from '../molecules/language-select';
import classNames from 'classnames';

const AuthTemplate = ({
	children,
	title,
	className,
	...props
}: React.HTMLAttributes<HTMLDivElement>) => {
	return (
		<div
			className={classNames('relative min-h-screen login-bg')}
			{...props}
		>
			<Title title={title || ''} />
			<main className="grid justify-items-center gap-y-6 md:gap-y-8 lg:gap-y-12">
				<Card className="p-3 w-3/4 sm:w-1/2">
					<LanguageSelect className="justify-self-end" />
				</Card>
				<SVGIcon className="w-72 h-auto" icon="Logo" />
				{children}
			</main>
		</div>
	);
};

export default AuthTemplate;
